import { render, staticRenderFns } from "./CV-Long-Content.vue?vue&type=template&id=499fc63a&scoped=true&"
import script from "./CV-Long-Content.vue?vue&type=script&lang=js&"
export * from "./CV-Long-Content.vue?vue&type=script&lang=js&"
import style0 from "./CV-Long-Content.vue?vue&type=style&index=0&id=499fc63a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499fc63a",
  null
  
)

export default component.exports